import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerProfile } from '../api/services/customerService';

let cachedProfileKey = null;
let cachedProfilePromise = null;

const getCachedCustomerProfile = (idCustomer, token) => {
  const profileKey = `${idCustomer}:${token}`;

  if (cachedProfileKey !== profileKey) {
    cachedProfileKey = profileKey;
    cachedProfilePromise = getCustomerProfile(idCustomer).catch((error) => {
      cachedProfileKey = null;
      cachedProfilePromise = null;
      throw error;
    });
  }

  return cachedProfilePromise;
};

/**
 * Custom hook to check if the logged-in user is a guest
 * @returns {Object} { isGuestUser: boolean, isLoading: boolean }
 */
export const useGuestCheck = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const [isGuestUser, setIsGuestUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserRole = async () => {
      const token = localStorage.getItem('token');

      // idCustomer has a default value for public product pricing, so it
      // cannot be used to determine whether a user is authenticated.
      if (!token) {
        setIsGuestUser(false);
        setIsLoading(false);
        return;
      }

      if (userInfo.role) {
        setIsGuestUser(userInfo.role === 'Guest');
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        if (userInfo.idCustomer) {
          const profileResult = await getCachedCustomerProfile(
            userInfo.idCustomer,
            token,
          );
          if (profileResult?.data?.role === 'Guest') {
            setIsGuestUser(true);
          } else {
            setIsGuestUser(false);
          }
        } else {
          setIsGuestUser(false);
        }
      } catch (error) {
        if (error.response?.status !== 401 && error.response?.status !== 403) {
          console.error('Error checking user role:', error);
        }
        setIsGuestUser(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkUserRole();
  }, [userInfo.idCustomer, userInfo.role]);

  return { isGuestUser, isLoading };
};
